import React from 'react';
export default /*#__PURE__*/React.forwardRef(function CardBackFace({
  children
}, ref) {
  return /*#__PURE__*/React.createElement("div", {
    className: "card-back-face",
    ref: ref
  }, children);
});